import type { RestaurantRole } from '@/bindings/RestaurantRole'
import { canManageBranch } from '@/lib/roles'

export type BranchHome =
  | '/$restaurantSlug/$branchSlug/manage/queue'
  | '/$restaurantSlug/$branchSlug/manage/settings'
  | '/$restaurantSlug/$branchSlug/manage/statistics'

/**
 * Where a role enters a branch: staff the queue; admin and above the settings, where the shop
 * opens and closes — or the statistics, the one page a closed branch keeps (2026-09-12).
 * Undefined when a closed branch has nothing for the role.
 */
export function branchHome(role: RestaurantRole): BranchHome
export function branchHome(role: RestaurantRole, closed: boolean): BranchHome | undefined
export function branchHome(role: RestaurantRole, closed = false): BranchHome | undefined {
  if (!canManageBranch(role)) return closed ? undefined : '/$restaurantSlug/$branchSlug/manage/queue'
  return closed ? '/$restaurantSlug/$branchSlug/manage/statistics' : '/$restaurantSlug/$branchSlug/manage/settings'
}
